/* assets/littleg-family-mission-records.js — FAMILY-MISSION-RECORDS-08
 * Private Family mission-record bridge for [data-littleg-game-app].
 * Completed public Place missions may update an EXISTING Family Private social place only.
 */
(function (window, document) {
  'use strict';
  var VERSION = '2026-09-16-family-mission-records-08';
  var GLOBAL_KEY = '__LITTLEG_FAMILY_MISSION_RECORDS_RUNTIME__';
  var ROOT_SELECTOR = '[data-littleg-game-app]';
  var SHARE_SELECTOR = '[data-lg-share], [data-share-mission-card], [data-copy-challenge]';
  var FAMILY_ME_SELECTOR = '[data-app-sidebar-link="account"]';
  var KID_MAP_RETURN_KEY = 'littleg_kid_mission_return_v1';
  var PARENT_CONFIRMATION_DELAY_MS = 650;
  var KID_RETURN_MAX_AGE_MS = 86400000;
  /** @type {Set<DirectoryRoot>} */
  const mountedRoots = new Set();
  var stateByRoot = new WeakMap();

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }
  function clean(value, maxLength) {
    var output = String(value == null ? '' : value).trim();
    return maxLength ? output.slice(0, maxLength) : output;
  }
  function list(root, selector) {
    return root && root.querySelectorAll
      ? Array.prototype.slice.call(root.querySelectorAll(selector))
      : [];
  }
  function slug(value, fallback) {
    var normalized = clean(value, 160)
      .toLowerCase()
      .replace(/_/g, '-')
      .replace(/[^a-z0-9\u3400-\u9fff-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 120);
    return normalized || fallback || 'today';
  }
  function todayHongKong() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Hong_Kong',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date());
    } catch (_) {
      return new Date().toISOString().slice(0, 10);
    }
  }
  function currentUrl() {
    try {
      return new URL(window.location.href);
    } catch (_) {
      return null;
    }
  }
  function roundKey(root) {
    var url = currentUrl();
    return clean(
      (root && root.dataset.missionRoundKey) ||
        (url && (url.searchParams.get('round_key') || url.searchParams.get('g'))) ||
        'today',
      160
    );
  }
  function publicPlaceId(root) {
    var url = currentUrl();
    return clean(
      (root && root.dataset.placeId) || (url && url.searchParams.get('place_id')) || '',
      160
    );
  }
  function readKidMapReturnContext() {
    try {
      var raw = JSON.parse(window.sessionStorage.getItem(KID_MAP_RETURN_KEY) || 'null');
      if (!raw || typeof raw !== 'object' || raw.source !== 'kid-map') return null;
      var placeId = clean(raw.place_id, 160);
      if (!placeId) return null;
      var created = Date.parse(clean(raw.created_at));
      if (Number.isFinite(created) && Date.now() - created > KID_RETURN_MAX_AGE_MS) {
        window.sessionStorage.removeItem(KID_MAP_RETURN_KEY);
        return null;
      }
      return { source: 'kid-map', place_id: placeId, return_to: '/pages/littleg-map' };
    } catch (_) {
      return null;
    }
  }
  function entrySource(root, placeId) {
    var url = currentUrl();
    if (url && url.searchParams.get('source') === 'kid-map') return 'kid-map';
    var context = readKidMapReturnContext();
    return context && context.place_id === placeId ? 'kid-map' : 'littleg-family';
  }
  function readFoundClueIndexes(root) {
    var key = 'littleg_game_reference_clues_' + slug(roundKey(root), 'default');
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(key) || '[]');
      return Array.isArray(parsed)
        ? parsed.map(Number).filter(function (v, i, a) {
            return v >= 0 && v <= 2 && a.indexOf(v) === i;
          })
        : [];
    } catch (_) {
      return [];
    }
  }
  function selectedClues(root) {
    var labels = [
      clean(root.dataset.missionClue1, 240),
      clean(root.dataset.missionClue2, 240),
      clean(root.dataset.missionClue3, 240),
    ];
    return readFoundClueIndexes(root).map(function (i) {
      return labels[i] || '線索 ' + (i + 1);
    });
  }
  function guessSummary(root) {
    var screen = root.querySelector('[data-lg-screen="guess"]');
    if (!screen) return {};
    var summary = {};
    list(screen, 'input, select, textarea').forEach(function (control) {
      if (control.disabled || !clean(control.value)) return;
      var key = clean(
        control.name ||
          control.id ||
          control.getAttribute('data-lg-guess-field') ||
          control.type ||
          'answer',
        120
      );
      key = slug(key, 'answer').replace(/-/g, '_');
      if (
        key.indexOf('latitude') !== -1 ||
        key.indexOf('longitude') !== -1 ||
        key === 'lat' ||
        key === 'lng'
      )
        return;
      summary[key] = clean(control.value, 240);
    });
    return summary;
  }
  function toast(root, message) {
    var state = stateByRoot.get(root);
    var node = root && root.querySelector('[data-lg-toast]');
    if (!state || !node) return;
    node.textContent = clean(message, 240);
    node.hidden = false;
    if (state.toastTimer != null) window.clearTimeout(state.toastTimer);
    state.toastTimer = window.setTimeout(function () {
      state.toastTimer = null;
      if (state.active && node.isConnected) node.hidden = true;
    }, 3200);
  }
  function enforceProfileAuthority(root) {
    if (!root) return;
    var authoritative = root.dataset.profileStatsAuthority === 'customer-metafields';
    var stats = root.querySelector('[data-lg-header-stats]');
    if (stats) {
      stats.hidden = !authoritative;
      stats.setAttribute('aria-hidden', authoritative ? 'false' : 'true');
    }
    if (!authoritative) {
      [
        '[data-lg-header-streak]',
        '[data-lg-header-stars]',
        '[data-lg-header-level]',
        '[data-lg-profile-level]',
        '[data-lg-profile-xp]',
        '[data-lg-profile-xp-target]',
        '[data-lg-profile-streak]',
      ].forEach(function (selector) {
        list(root, selector).forEach(function (node) {
          node.textContent = '—';
        });
      });
      var meter = root.querySelector('[data-lg-profile-progress]');
      if (meter) {
        meter.hidden = true;
        meter.setAttribute('aria-hidden', 'true');
      }
      root.setAttribute('data-profile-stats-render-state', 'not-authoritative');
      return;
    }
    root.setAttribute('data-profile-stats-render-state', 'customer-metafields');
  }
  function emitMissionState(root, record) {
    if (!record) return;
    try {
      window.dispatchEvent(new CustomEvent('littleg:mission-state', { detail: record }));
      root.setAttribute('data-result-state-status', 'emitted');
    } catch (_) {
      root.setAttribute('data-result-state-status', 'emit-failed');
    }
  }
  function buildRecord(root) {
    var round = roundKey(root);
    var mission = clean(root.dataset.missionHandle || round || 'today-city-exploration', 160);
    var city = clean(root.dataset.city || 'hong-kong', 120);
    var district = clean(root.dataset.district || 'hong-kong', 120);
    var clues = selectedClues(root);
    var placeId = publicPlaceId(root);
    var source = entrySource(root, placeId);
    return {
      result_id: 'family-mission-' + slug(round, 'today') + '-' + todayHongKong(),
      story_id: clean(round, 160),
      round_key: clean(round, 160),
      daily_scene_id: mission,
      mission_handle: mission,
      mission_name: clean(root.dataset.missionName || '今日城市探索', 240),
      mission_description: clean(root.dataset.missionDescription, 800),
      city_pack_id: clean(root.dataset.cityPackId || 'hk', 80),
      city: city,
      district: district,
      location: district,
      place_id: placeId,
      entry_source: source,
      return_to: source === 'kid-map' ? '/pages/littleg-map' : '',
      clues: clues,
      selected_clue_labels: clues,
      clue_count: clues.length,
      three_clues_complete: clues.length === 3,
      guess: guessSummary(root),
      status: 'local_saved',
      source: 'littleg-family-notice',
      storage_path: 'family',
      precise_location_saved: false,
      completed_at: new Date().toISOString(),
    };
  }
  function localeKidMapPath() {
    var path = window.location.pathname || '';
    var marker = '/pages/';
    var index = path.indexOf(marker);
    var prefix = index >= 0 ? path.slice(0, index) : '';
    return prefix + '/pages/littleg-map';
  }
  function ensureKidMapReturnAction(record) {
    if (!record || record.entry_source !== 'kid-map' || !record.place_id) return;
    list(document, '[data-littleg-result-card]').forEach(function (card) {
      var action = card.querySelector('[data-kid-map-return]');
      if (!action) {
        var host = card.querySelector('.littleg-mission-result-card__actions--secondary');
        if (!host) return;
        action = document.createElement('a');
        action.className = 'lcme__btn';
        action.setAttribute('data-kid-map-return', '');
        host.appendChild(action);
      }
      action.textContent = /^zh\b/i.test(document.documentElement.lang || '')
        ? '★ 返回我的好友地圖'
        : '★ Back to my Friend Map';
      action.href =
        localeKidMapPath() +
        '?source=mission-complete' +
        '&place_id=' +
        encodeURIComponent(record.place_id);
      action.hidden = false;
    });
  }
  function markKidMapMissionComplete(familyData, record) {
    if (
      !familyData ||
      !familyData.socialGraph ||
      record.entry_source !== 'kid-map' ||
      !record.place_id
    )
      return null;
    if (typeof familyData.socialGraph.markMissionComplete !== 'function') return null;
    try {
      return familyData.socialGraph.markMissionComplete(record.place_id, {
        round_key: record.round_key,
        mission_handle: record.mission_handle,
        completed_at: record.completed_at,
      });
    } catch (_) {
      return null;
    }
  }
  function saveMission(root, source) {
    if (!root || !stateByRoot.has(root)) return null;
    var round = roundKey(root);
    if (root.getAttribute('data-family-mission-record-saved') === round) return null;
    if (root.dataset.guessSubmitted !== 'true') {
      root.setAttribute('data-family-mission-record-status', 'guess-not-confirmed');
      return null;
    }
    var record = buildRecord(root);
    if (record.three_clues_complete !== true) {
      root.setAttribute('data-family-mission-record-status', 'three-clues-required');
      return null;
    }
    record.completion_source = clean(source || 'canonical-reveal', 120);
    emitMissionState(root, record);
    var saved = null;
    var familyData = window.LittleGFamilyData;
    var resultStorage = window.LittleGResultStorage;
    if (familyData && typeof familyData.saveRecord === 'function') {
      try {
        saved = familyData.saveRecord('mission', record);
      } catch (_) {
        saved = null;
      }
    }
    if (!saved && resultStorage && typeof resultStorage.saveResult === 'function') {
      try {
        saved = resultStorage.saveResult(record, 'family');
      } catch (_) {
        saved = null;
      }
    }
    if (saved) {
      root.setAttribute('data-family-mission-record-saved', round);
      root.setAttribute('data-family-mission-record-status', 'private-saved');
      markKidMapMissionComplete(familyData, record);
      ensureKidMapReturnAction(record);
      toast(root, '已私人保存到家庭記錄。');
    } else
      root.setAttribute(
        'data-family-mission-record-status',
        familyData || resultStorage ? 'save-failed' : 'storage-unavailable'
      );
    return saved;
  }
  function parentShareAuthorized() {
    var gate = window.LittleGParentGate;
    if (!gate || typeof gate.isAuthorized !== 'function') return false;
    try {
      return Boolean(gate.isAuthorized('external-share'));
    } catch (_) {
      return false;
    }
  }
  function sameOriginUrl(value) {
    var raw = clean(value);
    if (!raw) return null;
    try {
      var url = new URL(raw, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      return url;
    } catch (_) {
      return null;
    }
  }
  function parentConfirmationUrl() {
    var link = document.querySelector(FAMILY_ME_SELECTOR);
    var url = link ? sameOriginUrl(link.getAttribute('href') || link.href) : null;
    if (!url) return '';
    var returnUrl = window.location.pathname + window.location.search + window.location.hash;
    url.searchParams.set('source', 'family-mission-share');
    url.searchParams.set('intent', 'parent-confirmation');
    url.searchParams.set('return_url', clean(returnUrl, 1200));
    url.hash = 'family-account';
    return url.pathname + url.search + url.hash;
  }
  function routeToParentConfirmation(root) {
    var state = stateByRoot.get(root);
    var destination = parentConfirmationUrl();
    if (!state || !destination) return false;
    root.setAttribute('data-family-share-status', 'routing-to-parent-confirmation');
    if (state.redirectTimer != null) window.clearTimeout(state.redirectTimer);
    state.redirectTimer = window.setTimeout(function () {
      state.redirectTimer = null;
      if (state.active) window.location.assign(destination);
    }, PARENT_CONFIRMATION_DELAY_MS);
    return true;
  }
  function blockUnconfirmedShare(event, button, root) {
    if (!root || parentShareAuthorized()) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    var action = clean(
      button.getAttribute('data-lg-share') ||
        button.getAttribute('data-share-mission-card') ||
        button.getAttribute('data-copy-challenge') ||
        'share',
      120
    );
    var gate = window.LittleGParentGate;
    if (gate && typeof gate.request === 'function') {
      try {
        gate.request('external-share', {
          source: 'family-mission-share',
          action: action,
          return_url: clean(
            window.location.pathname + window.location.search + window.location.hash,
            1200
          ),
        });
      } catch (_) {}
    }
    root.setAttribute('data-family-share-status', 'parent-confirmation-required');
    toast(root, '分享前需要家長確認，正在前往「我的」。記錄仍保持私人。');
    routeToParentConfirmation(root);
    return true;
  }
  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    stateByRoot.set(root, { active: true, toastTimer: null, redirectTimer: null });
    mountedRoots.add(root);
    root.setAttribute('data-family-mission-record-policy', VERSION);
    enforceProfileAuthority(root);
  }
  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.active = false;
    if (state.toastTimer != null) window.clearTimeout(state.toastTimer);
    if (state.redirectTimer != null) window.clearTimeout(state.redirectTimer);
    mountedRoots.delete(root);
    stateByRoot.delete(root);
    root.removeAttribute('data-family-mission-record-policy');
    root.removeAttribute('data-family-share-status');
  }
  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    list(target, ROOT_SELECTOR).forEach(mount);
  }
  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    list(target, ROOT_SELECTOR).forEach(destroy);
  }
  document.addEventListener(
    'click',
    function (event) {
      var target =
        event.target && event.target.closest ? event.target.closest(SHARE_SELECTOR) : null;
      if (!target) return;
      var root = target.closest(ROOT_SELECTOR);
      if (!root) return;
      if (!stateByRoot.has(root)) mount(root);
      blockUnconfirmedShare(event, target, root);
    },
    true
  );
  document.addEventListener('littleg:screen-change', function (event) {
    var detail = event && event.detail ? event.detail : {};
    mountedRoots.forEach(function (root) {
      enforceProfileAuthority(root);
      if (detail.view !== 'reveal' || root.dataset.guessSubmitted !== 'true') return;
      saveMission(root, detail.source || 'canonical-reveal');
    });
  });
  document.addEventListener('littleg:game-ready', function () {
    mountedRoots.forEach(enforceProfileAuthority);
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target || document);
  });
  window[GLOBAL_KEY] = { version: VERSION, boot: boot, destroy: destroyAll, save: saveMission };
  window.__LITTLEG_FAMILY_MISSION_RECORDS__ = VERSION;
  if (document.readyState === 'loading')
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        boot(document);
      },
      { once: true }
    );
  else boot(document);
})(window, document);
